import { BookLockOutlineIcon } from './BookLockOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 2E088838-572B-45AC-B250-1C86900B787E
 * name book-lock-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-lock-outline.svg
 * tags
 * - Lock 
 */
export const BookSecureOutlineIcon = BookLockOutlineIcon;
export default BookSecureOutlineIcon